import { AuditTrail } from '@card-software/nexus-models';
import { LotItem } from '../inventory/lot-item';

export enum ShipmentStatus {
  Draft,
  InRoute,
  Arrived,
  InCustoms,
  ReadyToUnload,
  Unloading,
  Completed,
  Cancelled,
}

export enum IncomingShipmentType {
  Standard = 0,
  Consignment = 1,
}

export interface Shipment extends AuditTrail {
  id: string;
  trackingNumber: string;
  files: File[];
  lotIds: string[];
  invoiceReferences: string[];
  deliveryNoteReferences?: string[];
  estimatedArrivalDate: Date;
  actualArrivalDate: Date;
  shipmentNumber?: string;
  purchaseOrderReference?: string;
  purchaseOrderNumber: string;
  shipmentDate: Date;
  status: number;
  type: IncomingShipmentType;
  clientReference?: string;
}

export interface File {
  name: string;
  presignedUrl: string;
}

export interface InvoiceLotAction {
  invoiceReference: string;
  newLots: LotItem[];
  lotIdsToDelete: string[];
}

export interface ShipmentStatusCommand {
  newStatus: number;
}
